import { ReportFeatures } from '@hcs/types';

export const REPORT_PUBLIC_LINK_READ_ONLY_FEATURES = [
  ReportFeatures.PublicLinks,
];
